import { Cmp, Ctrl } from ":mods";

export function TopSelector(props: Ctrl.Nav.model.TopNavJSXItemProps) {
  return <Cmp.I18n.LanguageSelector />;
}
